import { render, staticRenderFns } from "./ifp-filter-title-ref-search.vue?vue&type=template&id=4c21dd6c&"
import script from "./ifp-filter-title-ref-search.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-title-ref-search.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-filter-title-ref-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports